import { render, staticRenderFns } from "./modal-document-preview.vue?vue&type=template&id=30e80827&scoped=true"
import script from "./modal-document-preview.vue?vue&type=script&lang=js"
export * from "./modal-document-preview.vue?vue&type=script&lang=js"
import style0 from "./modal-document-preview.vue?vue&type=style&index=0&id=30e80827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e80827",
  null
  
)

export default component.exports